export function prepLocation(locationDTO) {
    const { lat, lng } = locationDTO;
    return { lat: Number(lat), lng: Number(lng) };
}
